import { createFileRoute } from '@tanstack/react-router';

import { getPage } from '@/lib/content-registry';
import { pageSchema, seoHead } from '@/lib/seo';
import { ControlHome } from '@/blocks/control-home';
import { Footer } from '@/blocks/footer';
import { Header } from '@/blocks/header';
import { StructuredData } from '@/components/control-resonant/structured-data';

export const Route = createFileRoute('/')({
  head: () => seoHead(getPage('/')!),
  component: Home,
});
function Home() {
  return (
    <>
      <Header />
      <main id="main-content">
        <StructuredData data={pageSchema(getPage('/')!)} />
        <ControlHome />
      </main>
      <Footer />
    </>
  );
}
